import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

function cake2fill(props: IconProps) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.333 4v2.666h2V4h1.334v2.666h2V4H12v2.666h.667a2 2 0 011.996 1.883l.004.118v.666c0 .676-.252 1.294-.666 1.764L14 14a.666.666 0 01-.667.667H2.667A.667.667 0 012 14v-2.907a2.683 2.683 0 01-.648-1.454l-.015-.169-.004-.137v-.666A2 2 0 013.216 6.67l.117-.003L4 6.666V4h1.333zm7.334 4H3.333a.667.667 0 00-.662.589l-.004.078v.647l.002.098a1.334 1.334 0 002.651.121l.01-.102.003-.117c.024-.832 1.218-.862 1.326-.09l.007.09.003.098a1.333 1.333 0 002.661.02l.008-.187c.083-.771 1.241-.771 1.324 0l.008.188a1.333 1.333 0 002.66 0l.003-.1v-.666a.667.667 0 00-.588-.662L12.667 8zm-8-7.333c.88.58 1.108 1.392.966 1.925A1 1 0 013.7 2.075c.199-.74.966-.408.966-1.408zM8 .667c.88.58 1.109 1.392.966 1.925a1 1 0 11-1.932-.517c.2-.74.966-.408.966-1.408zm3.333 0c.88.58 1.109 1.392.966 1.925a1 1 0 11-1.932-.517c.2-.74.966-.408.966-1.408z"
                fill={props.color || "#fff"}
            />
        </svg>
    )
}

export default cake2fill
